"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FooterTotal = ({ total }) => {
    return ((0, jsx_runtime_1.jsx)("tfoot", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { colSpan: 5 }), (0, jsx_runtime_1.jsx)("td", { className: "bold text-right", children: "TOTAL" }), (0, jsx_runtime_1.jsx)("td", { className: "bold", children: total })] }) }));
};
exports.default = FooterTotal;
